define.alias("shared/components/shared/card/footer", "preview-grid/components/shared/card/footer");